import { Injectable } from '@angular/core';

import { Store, select } from '@ngrx/store';

import * as fromRoot from 'src/app/modules/ngrx-store/reducers';
import * as TermsAndConditionsActions from 'src/app/modules/ngrx-store/terms-and-conditions/terms-and-conditions.actions';
import * as TermsAndConditionsSelectors from 'src/app/modules/ngrx-store/terms-and-conditions/terms-and-conditions.selectors';

@Injectable()
export class TermsAndConditionsFacade {
	termsAndConditions$ = this.store.pipe(select(TermsAndConditionsSelectors.getTermsAndConditions));
	loadTermsAndConditionsPending$ = this.store.pipe(select(TermsAndConditionsSelectors.getLoadTermsAndConditionsPending));
	loadTermsAndConditionsSuccess$ = this.store.pipe(select(TermsAndConditionsSelectors.getLoadTermsAndConditionsSuccess));
	loadTermsAndConditionsFailure$ = this.store.pipe(select(TermsAndConditionsSelectors.getLoadTermsAndConditionsFailure));
	acknowledgeTermsAndConditionsPending$ = this.store.pipe(select(TermsAndConditionsSelectors.getAcknowledgeTermsAndConditionsPending));
	acknowledgeTermsAndConditionsFailure$ = this.store.pipe(select(TermsAndConditionsSelectors.getAcknowledgeTermsAndConditionsFailure));
	acknowledgeTermsAndConditionsSuccess$ = this.store.pipe(select(TermsAndConditionsSelectors.getAcknowledgeTermsAndConditionsSuccess));

	constructor(protected store: Store<fromRoot.AppDomainPartialState>) { }

	loadTermsAndConditions(): void {
		this.store.dispatch(TermsAndConditionsActions.loadTermsAndConditions());
	}

	acknowledgeTermsAndConditions(publishDate: string): void {
		this.store.dispatch(TermsAndConditionsActions.acknowledgeTermsAndConditions({ publishDate }));
	}
}